import { useLayoutEffect, useState } from 'react';

type PT = {
  value: string;
};
export const useDescriptionEditorValueHandler = ({ value }: PT) => {
  const [isImgGoingAfterText, setIsImgGoingAfterText] = useState(false);
  const [isImgFirst, setIsImgFirst] = useState(false);

  useLayoutEffect(() => {
    if (value) {
      const el = document?.createElement('section');
      // console.log('description:', description);
      el.innerHTML = value?.trim();
      const childNodes = el?.children;
      const firstNode = childNodes[0];
      const indexOfImgTag = firstNode?.innerHTML?.indexOf('<img');
      if (indexOfImgTag > 0) {
        setIsImgGoingAfterText(true);
      } else if (indexOfImgTag === 0) {
        setIsImgFirst(true);
      }
    }

    // console.log('san:', initData);
  }, [value]);

  return {
    isImgGoingAfterText,
    isImgFirst,
  };
};
